/**
 * reCAPTCHA v3 configuration.
 *
 * The site key is public by design - it ships in the page source of every site
 * that uses reCAPTCHA and is meaningless without the secret, which lives only as
 * a Supabase Edge Function secret and never enters this repository. So it is
 * committed rather than injected as a build variable: a missing environment
 * variable in Netlify would silently disable the captcha in production, which is
 * the one failure mode worth engineering away.
 *
 * AN EMPTY siteKey DISABLES THE CAPTCHA ENTIRELY. The form then submits without
 * a token, which the backend accepts as long as `forms.sites.captcha_required`
 * is false. That is the intended state until scores have been observed - see the
 * shadow-mode note in the forms_recaptcha_support migration.
 */
export const RECAPTCHA = {
  siteKey: '6Lcsa2YtAAAAAIc0prw1Ug44ErgdL02b-feh2Vzx',

  /**
   * Sent with the token and returned by Google in the verification response, so
   * a score can be attributed to a specific interaction. Lowercase with
   * underscores: Google restricts this to `A-Za-z/_`.
   */
  action: 'contact_enquiry',

  /**
   * The phone reveal's own action, kept separate from the enquiry's.
   *
   * Two interactions with very different shapes - one follows a minute of typing,
   * the other is a single click on a freshly loaded page - and a shared action
   * name would average their scores together in Google's admin console. Judging a
   * threshold then means judging a blend of two populations, which is how a
   * sensible-looking cutoff ends up refusing one of them.
   */
  revealAction: 'phone_reveal',
} as const;

export const captchaConfigured = (): boolean => RECAPTCHA.siteKey.length > 0;
